import AlertBannerProvider from '@src/providers/AlertBannerProvider'
import { Outlet } from 'react-router-dom'
import AppHeader from './AppHeader'

const TemplateGlobal = () => {
  return (
    <AlertBannerProvider>
      <AppHeader />
      <Outlet />
    </AlertBannerProvider>
  )
}

export default TemplateGlobal
